import { createReducer, on } from '@ngrx/store';
import * as LocationCardActions from '../actions';
import { findFieldById } from '../configs/base-utils';
import { BasicInfoCommonFieldIds } from '../configs/common.models';
import { ConfirmationType } from 'app/shared/models/monitorsetting';
import { initialState } from './state'

export const uiReducer = createReducer(
    initialState,
    on(LocationCardActions.setMapCoords, (state, { coords }) => {
        const formState = { ...state.formState };
        const latitudeField = findFieldById(formState, BasicInfoCommonFieldIds.Latitude);
        const longitudeField = findFieldById(formState, BasicInfoCommonFieldIds.Longitude);

        latitudeField.value = Number(coords.lat.toFixed(4));
        longitudeField.value = Number(coords.lon.toFixed(4));

        return { ...state, formState, pristine: false };
    }),

    on(LocationCardActions.setFormValidity, (state, { valid }) => {
        if (state.valid === valid) {
            return state;
        }
        return { ...state, valid };
    }),

    on(LocationCardActions.closeDialog, (state) => {
        if (state.pristine) {
            return state;
        }
        return { ...state, confirmation: { ...state.confirmation, show: true, action: ConfirmationType.Close } };
    }),

    on(LocationCardActions.openLocationDashboard, (state) => {
        if (state.pristine) {
            return state;
        }
        return {
            ...state,
            confirmation: { ...state.confirmation, show: true, action: ConfirmationType.LocationDashboard },
        };
    }),

    on(LocationCardActions.collectLocation, (state) => {
        if (state.pristine) {
            return state;
        }
        return {
            ...state,
            confirmation: { ...state.confirmation, show: true, action: ConfirmationType.DataCollection },
        };
    }),

    on(LocationCardActions.scheduleCollect, (state) => {
        if (state.pristine) {
            return state;
        }
        return {
            ...state,
            confirmation: { ...state.confirmation, show: true, action: ConfirmationType.ScheduleCollection },
        };
    }),

    on(LocationCardActions.exportXml, (state) => {
        if (state.pristine) {
            return state;
        }
        return {
            ...state,
            confirmation: {
                ...state.confirmation,
                show: true,
                action: ConfirmationType.LocationExport,
                data: {
                    ...state.confirmation.data,
                    message: 'ADD_EDIT.EDIT_CONFIRM_CONTENT',
                },
            },
        };
    }),

    on(LocationCardActions.clearConfirmation, (state) => ({
        ...state,
        confirmation: initialState.confirmation,
    })),

    on(LocationCardActions.setFromHomeDashboard, (state, { fromHomeDashboard }) => ({
        ...state,
        fromHomeDashboard,
    })),
    on(LocationCardActions.closeSiltDialog, (state, { updateFieldId, lastEditedValue }) => {
        const formState = { ...state.formState };

        const field = findFieldById(formState, updateFieldId);
        
        if (field) {
            field.value = lastEditedValue;
        }
        
        return { ...state, formState, pristine: false };
    }),
);
